import { render, staticRenderFns } from "./ApplicantProfessionData.vue?vue&type=template&id=f2295e22&"
import script from "./ApplicantProfessionData.vue?vue&type=script&lang=js&"
export * from "./ApplicantProfessionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports